import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "../auth";
import Loader from "./loader";
import Text from "./text";

export function RequireAuth({ children, admin = false }: { children: ReactNode; admin?: boolean }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending)
    return (
      <div className="grid min-h-dvh place-items-center text-muted-foreground">
        <Loader />
      </div>
    );
  if (me.isError)
    return (
      <div className="grid min-h-dvh place-items-center">
        <Text.Danger>Can't reach the server.</Text.Danger>
      </div>
    );
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && !me.data.is_admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
